import React, { useState } from "react";
import { FormGroup, FormGroupLabel, Select } from "gumdrops";

export default function MoveToFolderForm() {
  const [campaigns, setCampaigns] = useState({ fruit: 1 });

  const _handleSelectChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setCampaigns({ [name]: value });
  };

  return (
    <div>
      <FormGroup>
        <FormGroupLabel text="Folder *" />
        <Select
          options={myOptions}
          name="fruit"
          value={campaigns}
          onChange={_handleSelectChange}
          size="sm"
        />
      </FormGroup>
    </div>
  );
}

const myOptions = [
  { name: "Dev: Make this a Search Select UI element", value: 1 },
  { name: "apples", value: 2 },
];
